import { LegacyDashboardWarningSettingKey } from "./legacy-warning-setting-keys";

export const warningTypes: Array<{
  label: string;
  value: LegacyDashboardWarningSettingKey;
}> = [
  {
    label: "Waterkeringen waarschuwingen",
    value: "warnings_water_authorities",
  },
  {
    label: "Provincie waarschuwingen",
    value: "warnings_provinces",
  },
];

export const warningOptions: Record<LegacyDashboardWarningSettingKey, string[]> = {
  warnings_water_authorities: [
    "Waternet",
    "Waterschap_Goeree_Overflakkee",
    "Waterschap_Voorne_Putten_Rozenburg",
    "Waterschap_IJsselmonde_plus",
    "Waterschap_De_Maaskant",
    "Waterschap_De_Aa",
    "Waterschap_Walcheren",
    "Waterschap_Zeeuws_Vlaanderen",
    "Waterschap_BrabantseDelta",
    "Waterschap_Schouwen_Duiveland",
    "Waternet_Amsterdam",
    "Waternet_Bijlmermeer",
    "Waternet_Weesp",
    "Waternet_Maarssen",
    "Waternet_Mijdrecht",
    "Oude_IJssel_Baakse_Beek",
    "Liemers_Veluwe",
    "Schipbeek_Berkel",
    "HMCZ_Zoommeer",
    "HMCZ_Veersemeer",
  ],
  warnings_provinces: [
    "WAE",
    "GR",
    "FR",
    "DR",
    "NH",
    "FL",
    "OV",
    "GL",
    "UT",
    "ZH",
    "ZE",
    "NB",
    "LB",
    "WAD",
    "IJG",
  ],
};
